import type { FgaAssignableRelation } from './generated/model'

export const SUPPLIER_ORGANISATION_PERMISSIONS = ['create'] as const
export type SupplierOrganisationPermission = (typeof SUPPLIER_ORGANISATION_PERMISSIONS)[number]

export const SUPPLIER_RECORD_VERBS = [
  'view',
  'view_tprm',
  'manage_tprm',
  'view_related_requests',
  'view_related_agreements',
  'view_related_documents',
  'view_related_submissions',
  'edit',
  'edit_documents',
  'manage_documents',
  'manage_internal_contacts',
  'manage_external_contacts',
  'manage_products',
  'add_agreement',
  'administer',
] as const
export type SupplierRecordPermission = (typeof SUPPLIER_RECORD_VERBS)[number]

/**
 * The supplier permission vocabulary a permission set configures. Orthogonal rather than tiered, so
 * one toggle is one tuple.
 */
export const SUPPLIER_PERMISSIONS = [...SUPPLIER_ORGANISATION_PERMISSIONS, ...SUPPLIER_RECORD_VERBS] as const
export type SupplierPermission = (typeof SUPPLIER_PERMISSIONS)[number]

/**
 * What a flat assignee held before access became grantable. Despite the name, nothing provisions this
 * — a set created through the API confers nothing until an organisation enables a permission.
 * Benchmarks and parity tests use it to stand in for the pre-grant access.
 */
export const DEFAULT_SUPPLIER_PERMISSIONS: readonly SupplierPermission[] = SUPPLIER_RECORD_VERBS.filter(
  (permission) => permission !== 'administer'
)

export const supplierGrantsRelation = (
  permission: SupplierPermission
): Extract<FgaAssignableRelation<'supplier_permission_set'>, `grants_${string}`> => `grants_${permission}`
